import React from 'react'
import styled from 'styled-components'
import Headroom from 'react-headroom'
import Link, { replace } from 'gatsby-link'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as Styles from '../assets/_styles'

const HeaderContainer = styled.div`
  padding: 0 48px;
  height: 80px;
  z-index: 2050;
`

const HeaderContent = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  ${Styles.media.tablet`justify-content: center;`} align-items: center;
  height: 100%;
`

const Logo = styled.div`
  font-weight: 600;
  font-size: 1.5em;
  display: inline-block;
  letter-spacing: 3px;
  user-select: none;
  margin-right: -3px;
  svg {
    max-width: 32px;
  }
  path {
    fill: white;
    stroke: transparent;
  }
  > span {
    position: relative;
    cursor: default;
  }
  > span:before {
    content: '';
    position: absolute;
    width: 0%;
    height: 2px;
    background-color: #333;
    bottom: 0;
    left: 0;
    transition: all 0.2s ease-in-out 0s;
  }

  > span:hover:before {
    width: 100%;
  }
`

const Links = styled.div`
  text-transform: lowercase;
  white-space: nowrap;
  ${Styles.media.tablet`
    display: none;
  `} > a {
    font-size: 0.9em;
    font-weight: 400;
    margin: 0 12px;
    white-space: nowrap;
    &:hover:before {
      width: 100%;
    }
    &:before {
      content: '';
      position: absolute;
      width: 0%;
      height: 2px;
      background-color: currentColor;
      bottom: -1px;
      left: 0;
      transition: all 0.2s ease-in-out 0s;
    }
  }
`

const NavLink = ({ dest, name, click }) => {
  if (typeof location !== 'undefined' && location.pathname !== '/') {
    return <Link to={`/${dest}`}>{name}</Link>
  } else {
    return (
      <a
        onClick={() => {
          document.querySelector(dest).scrollIntoView({
            block: 'start',
            inline: 'nearest',
            behavior: 'smooth',
          })
          if (click) {
            click()
          }
        }}
      >
        {name}
      </a>
    )
  }
}

const ZincLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="253"
    height="250"
    viewBox="0 0 253 250"
  >
    <g stroke="#000">
      <path
        id="bottom"
        d="M2.28385796,189.539451 C0.0298873288,203.360747 -0.218644386,210.44789 2.26128994,218.807097 C11.4624914,240.80997 27.4909532,250.666132 51.3599828,248.701604 C59.0597894,248.083371 65.6968196,248.040621 78.9878159,248.307508 C79.4648736,248.317105 79.4648736,248.317105 79.9418907,248.326737 C86.3791034,248.456713 89.2356345,248.5 92.7989583,248.500001 C112.799421,248.458333 128.787153,248.45 164.75,248.45 C200.712153,248.45 216.699421,248.441667 236.7,248.4 C246.791439,248.4 251.708739,244.232003 252.200737,235.572866 C252.688232,226.602946 247.543398,220.760069 238.029289,219.594975 C236.045995,219.311647 234.05587,219.237939 230.926809,219.266646 C230.590727,219.269729 230.319024,219.272846 229.717645,219.280209 C228.503218,219.29508 227.969121,219.3 227.3,219.3 C167.5,219.3 167.5,219.3 107.7,219.3 C77.8,219.3 77.8,219.3 47.9,219.3 C39.1406296,219.3 34.8495661,217.719082 32.6338672,211.780887 C29.7556803,204.364021 30.5092268,197.556118 35.4250811,191.869189 C36.2058079,190.984365 37.0024257,190.180926 38.3693771,188.866049 C38.4897536,188.750259 38.6217154,188.623524 38.8731221,188.382114 C39.0775638,188.185728 39.2265249,188.042346 39.3725636,187.901234 C39.7482365,187.538234 40.0570904,187.235803 40.3502685,186.942666 C47.6348091,179.813115 55.0673475,172.543313 65.0238802,162.80812 C66.8509535,161.021664 68.7232078,159.191105 71.1911523,156.778177 C74.274552,153.763528 75.9842848,152.091917 77.3576789,150.749126 C82.3803672,145.838361 86.0615762,142.238889 89.6879103,138.692527 C109.675774,119.14546 124.450446,104.677247 138.948622,90.4442843 C146.93647,82.5538494 148.05302,73.0631711 141.849286,66.9563704 C135.716245,60.9206792 126.406719,61.9916866 118.247951,69.859068 C113.398077,74.5587911 108.36508,79.4381359 102.097616,85.5158886 C99.288297,88.240172 88.5082897,98.6948396 85.9443769,101.181165 C57.1640815,129.09053 39.7508356,145.941479 21.2466455,163.760329 C12.1698653,172.492421 6.14013399,180.417431 2.28385798,189.539451 Z"
      />
      <path
        id="top"
        d="M228.33148,5.92178198 C222.776147,2.41358033 216.186257,0.600260806 209.5,0.7 L19.9,0.7 C13.6382007,0.7 7.97963282,3.99176305 5.55272947,9.31221694 C3.9942741,12.6369217 3.92369954,16.0950753 5.56011785,20.0043177 C8.69872817,27.3842933 14.4859178,29.7459773 24.6833426,29.5002775 C26.0186979,29.4557657 27.357561,29.4472919 29.1542371,29.462518 C29.5638121,29.4659889 29.8851001,29.4693908 30.6315647,29.4778096 C32.1020452,29.4943939 32.7685433,29.5 33.6,29.5 C117.749701,29.5 155.11617,29.4833334 201.7,29.4 C211.333043,29.4 216.378042,31.5038721 219.164676,38.5154027 C220.441276,41.7289137 220.309917,44.5729666 218.97165,47.3148783 C217.968876,49.3694131 216.708478,50.8802422 213.744154,53.924123 C213.55778,54.1154625 213.55778,54.1154625 213.371863,54.3064657 C213.041792,54.645751 212.798098,54.8978217 212.558885,55.14814 C199.058882,69.0648104 188.24638,80.2106456 163.908877,105.298148 C139.57138,130.385646 128.758882,141.531477 115.259773,155.447223 C107.140164,163.860312 105.960171,172.566038 111.966397,178.959774 C118.309298,185.790591 127.700693,184.786309 136.143313,176.149608 C151.180073,160.842727 166.741498,144.94263 186.117269,125.100674 C194.628747,116.384409 227.850943,82.3369722 235.943332,74.0495891 C242.268232,67.6117443 246.229823,61.470106 248.118004,54.3670355 C253.645779,34.3288507 246.892161,17.8330426 228.331479,5.92178194 Z"
      />
    </g>
  </svg>
)

const Header = ({ siteTitle }) => (
  <Headroom
    disableInlineStyles
    wrapperStyle={{
      zIndex: 42069,
      position: 'absolute',
      width: '100vw',
      top: 0,
    }}
  >
    <HeaderContainer>
      <HeaderContent>
        <Logo>
          <Link to="/">
            <ZincLogo />
            {/* <span>{siteTitle}</span> */}
          </Link>
        </Logo>
        <Links>
          <NavLink dest="#who" name="About" />
          <NavLink dest="#api" name="API" />
          <NavLink dest="#products" name="Products" />
          <NavLink dest="#enterprise" name="Enterprise" />
          <NavLink dest="#contact" name="Contact Us" />
        </Links>
      </HeaderContent>
    </HeaderContainer>
  </Headroom>
)

const NavButtonContainer = styled.div`
  display: none;
  ${Styles.media.tablet`display: block;`} position: fixed;
  width: 100vw;
  bottom: 0;
  right: 0;
  z-index: 2019;
`

const NavButtonBars = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  border-radius: 100px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  color: white;
  transition: all 0.2s ease-in-out;
  ${props => props.isOpen && `transform: rotate(90deg);`} z-index: 3;
`

const NavButtonLinks = styled.div`
  text-align: right;
  color: #fff;
  position: absolute;
  bottom: 80px;
  right: 40px;
  z-index: 20000;
  > a {
    display: block;
    margin-bottom: 16px;
  }
  transition: all 0.2s ease-in-out;
  opacity: ${props => (props.isOpen ? '1' : '0')};
  pointer-events: ${props => (props.isOpen ? 'all' : 'none')};
`
const NavButtonBackground = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  background-color: rgba(0, 0, 0, 0.95);
  border-radius: 100px;
  width: 56px;
  height: 56px;
  transition: all 0.2s ease-in-out;
  transform: scale(${props => (props.isOpen ? '10.5' : '1')});
`

class NavButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false }
  }

  toggleOpen() {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    return (
      <NavButtonContainer>
        <NavButtonBars
          isOpen={this.state.isOpen}
          onClick={this.toggleOpen.bind(this)}
        >
          <FontAwesomeIcon icon={['fas', 'bars']} />
        </NavButtonBars>
        <NavButtonLinks isOpen={this.state.isOpen}>
          <NavLink
            click={this.toggleOpen.bind(this)}
            dest="#who"
            name="About"
          />
          <NavLink click={this.toggleOpen.bind(this)} dest="#api" name="API" />
          <NavLink
            click={this.toggleOpen.bind(this)}
            dest="#products"
            name="Products"
          />
          <NavLink
            click={this.toggleOpen.bind(this)}
            dest="#enterprise"
            name="Enterprise"
          />
          <NavLink
            click={this.toggleOpen.bind(this)}
            dest="#contact"
            name="Contact Us"
          />
        </NavButtonLinks>
        <NavButtonBackground isOpen={this.state.isOpen} />
      </NavButtonContainer>
    )
  }
}

export default { Header, NavButton }



// WEBPACK FOOTER //
// ./src/components/header.js